<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-terms custom-alert-modal"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc >
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close"></div>
                    <!-- <div>{{ title }}</div> -->
                    <div class="title" v-if="tag == 'terms'">{{lbl.register.pdpa.terms}}</div>
                    <div class="title" v-else>{{lbl.register.pdpa.privacy}}</div>
                </div>
                <div class="modal-base-body">
                    <iframe v-if="tag == 'terms'" class="iframe" :src="termsUrl"></iframe>
                    <iframe v-else class="iframe" :src="privacyUrl"></iframe>
                    <!-- <iframe id="iframe-id" seamless="seamless" class="iframe" :src="termsUrl"></iframe> -->
                </div>
                <div class="modal-base-footer">
                    <button class="btn-white" @click="clickOk()">{{ btnOk }}</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

import Vue from 'vue';
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import DateTimeHelper from '@/helper/DatetimeHelper.js';
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "AlertModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            isShowSmallClose: false,
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl(),
            termsUrl: '',
            privacyUrl: '',
            localeCode: Locale.getLocaleCode()

        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickSmallClose: function() {
            this.hide();
            this.controller.sendCallbackSmallClose({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.isShowSmallClose = config.isShowSmallClose;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            const date = new Date();
            const dateTime = DateTimeHelper.cleanTimeFormDatetime(date);
            const time = DateTimeHelper.convertDateToTimeStampUnix(dateTime);
            
            if (this.localeCode == 2052) {
                this.termsUrl = `${Vue.bzbsConfig.miscUrl}/bhp/termsandconditions.aspx?time=${time}&locale=2052`
                this.privacyUrl = `${Vue.bzbsConfig.miscUrl}/bhp/privacy_policy.aspx?time=${time}&locale=2052`
            } else {
                this.termsUrl = `${Vue.bzbsConfig.miscUrl}/bhp/termsandconditions.aspx?time=${time}&locale=${this.localeCode}`
                this.privacyUrl = `${Vue.bzbsConfig.miscUrl}/bhp/privacy_policy.aspx?time=${time}&locale=${this.localeCode}`
            }
            
            this.$bvModal.show(this.modalId);

        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
.modal-terms {
    @extend %modal-base;
    .modal {
        position: fixed;
        bottom: 0;
        z-index: 1050;
        width: 100%;
        height: auto;
    }
    .modal-dialog {
        margin: 0;
        max-width: 100%;
        height: 100%;
        .modal-content {
            border: 0px;
            border-radius: 0px;
            border-top-right-radius: 20px;
            border-top-left-radius: 20px;
            margin: 0;
            margin-left: auto;
            margin-right: auto;
            margin-top: auto;
            max-width: 100%;

            @media (min-width: $min-width-tablet) {
                margin-top: unset;
                margin: auto;
                border-radius: 20px;
                max-width: 688px;
            }
            .modal-body {
                padding: 30px 20px;
            }

            .modal-base {

                .modal-base-head {
                    .title {
                        text-align: center;
                        font-size: 18px;
                        color: #F06523;
                        font-weight: 700;
                        text-transform: uppercase;
                        margin-bottom: 16px;
                    }
                }

                .modal-base-body {
                    padding: 0;

                    .text-sub-title {
                        text-align: center;
                        font-size: 16px;
                        color: #000000;
                        font-weight: 400;
                        text-transform: uppercase;
                        margin-top: 10px;
                    }
                    iframe {
                        border: none;
                        height: calc(100vh - 250px);
                        width: 100%;

                    }
                }
                .modal-base-footer {
                    margin-top: 30px;
                    button {
                        padding: 0;
                    }
                    .btn-white {
                        margin-top: 16px;
                    }
                }
            }
        }
    }

}
</style>
